import { render, staticRenderFns } from "./PolicyExpress.vue?vue&type=template&id=484fb36e&scoped=true&"
import script from "./PolicyExpress.vue?vue&type=script&lang=js&"
export * from "./PolicyExpress.vue?vue&type=script&lang=js&"
import style0 from "./PolicyExpress.vue?vue&type=style&index=0&id=484fb36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484fb36e",
  null
  
)

export default component.exports